import { Component } from '@angular/core';

@Component({
    templateUrl: './canvas-help.component.html',
    standalone: false
})
export class CanvasHelpComponent{}

